// Platform page entry point

import { initNumberAnim } from '../../components/number-anim.js';
import { initPlatformLottie } from './lottie.js';
import { initCompaniesMarquee } from '../../components/companies-marquee.js';
import { initPlatformGrowth } from './platform-growth.js';
import { initPlatformWhy } from './platform-why.js';
import { navCloseMobile } from './nav-mobile.js';

// ─── Platform Lottie ──────────────────────────────────────────────────────────

initPlatformLottie().then(() => {
  setTimeout(() => {
    // ─── Number Animation ───────────────────────────────────────────────────

    initNumberAnim();
    ScrollTrigger.refresh();
  }, 100);
});
// init companies companies_logos
initCompaniesMarquee();

initPlatformGrowth();

initPlatformWhy();

navCloseMobile();
